import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  refreshProcessingTitle: {
    description: 'refreshTracking.processingTitle',
    defaultMessage: 'Processing',
    id: 'ItQAJU',
  },
  refreshProcessingContent: {
    description: 'refreshTracking.processingContent',
    defaultMessage: 'Your request is processing',
    id: 'AsvC9j',
  },
  refreshSuccessTitle: {
    description: 'refreshTracking.successTitle',
    defaultMessage: 'Refreshed',
    id: 'MkxTBy',
  },
  refreshSuccessContent: {
    description: 'refreshTracking.successContent',
    defaultMessage: 'Shipment tracking information refreshed successfully',
    id: 'AUo/4m',
  },
  refreshFailureTitle: {
    description: 'refreshTracking.failureTitle',
    defaultMessage: 'Refresh Failed',
    id: 'vVWo4v',
  },
  refreshFailureContent: {
    description: 'refreshTracking.failureContent',
    defaultMessage: 'An error occurred while attempting to refresh tracking status for these shipments',
    id: 'LLl3EZ',
  },
});
